export enum GenericEntitySearchType {
    Employer = 'Employer',
    TradingPartner = 'TradingPartner',
    Insurer = 'Insurer',
    RehabProviderGroup = 'RehabProviderGroup'
}
